import { Injectable } from '@angular/core';
import { ApiService } from './api';

import { RodeoEventRun } from '../model/rodeoEventRun';
import { BarrelSplitRun } from 'model/barrel-split-run';
import { BarrelSplitTimeRun } from 'lib/farmtek-reader';

@Injectable()
export class TimerService {
    constructor(private api: ApiService) { }

    getTimedRun(localUrl) {
        return new Promise((resolve, reject) => {
            this.api.getWithoutAuth(localUrl + 'getTimedRun')
            .then(data => resolve(data), error => reject(error));
        });
    }

    getTimeData(localUrl) {
        return new Promise((resolve, reject) => {
            this.api.getWithoutAuth(localUrl + 'getTimeData')
            .then(data => resolve(data), error => reject(error));
        });
    }

    getBarrelSplitRun(localUrl) : Promise<BarrelSplitTimeRun> {
        return new Promise((resolve, reject) => {
            this.api.getObjectWithoutAuth<BarrelSplitTimeRun>(localUrl + 'getBarrelSplitTimeRun')
            .then(data => resolve(data), error => reject(error));
        });
    }

    getRunningClock(rodeoId, accountId) {
        return new Promise((resolve, reject) => {
            this.api.getWithAuth(this.api.endpoints.timer + '/getRunningClock?rodeoId=' + rodeoId + '&accountId=' + accountId)
            .then(data => resolve(data), error => reject(error));
        });
    }

    getScoredRun(localUrl) {
        return new Promise((resolve, reject) => {
            this.api.getWithoutAuth(localUrl + 'getScoredRun')
            .then(data => resolve(data), error => reject(error));
        });
    }

    setSelectedRun(localUrl, run: RodeoEventRun, eventName, barrels) {
        return new Promise((resolve, reject) => {
            this.api.postWithoutAuth(localUrl + 'setSelectedRun?eventName=' + eventName + '&barrels=' + barrels, run)
            .then(data => resolve(data), error => reject(error));
        });
    }

    setOnlineSelectedRun(run: RodeoEventRun, rodeoId) {
        return new Promise((resolve, reject) => {
            this.api.postWithAuth(this.api.endpoints.timer + '/setSelectedRun?rodeoId=' + rodeoId, run)
            .then(data => resolve(data), error => reject(error));
        });
    }

    getSelectedRun(rodeoId, accountId) {
        return new Promise((resolve, reject) => {
            this.api.getWithAuth(this.api.endpoints.timer + '/getSelectedRun?rodeoId=' + rodeoId + '&accountId=' + accountId)
            .then(data => resolve(data), error => reject(error));
        });
    }

    setLeaders(localUrl, runs: RodeoEventRun[], eventName, eventType, barrels) {
        return new Promise((resolve, reject) => {
            this.api.postWithoutAuth(localUrl + 'setLeaders?eventName=' + eventName + '&eventType=' + eventType + '&barrels=' + barrels, runs)
            .then(data => resolve(data), error => reject(error));
        });
    }

    setGroupLeaders(localUrl, groupedRuns: any[], eventName, barrels) {
        return new Promise((resolve, reject) => {
            this.api.postWithoutAuth(localUrl + 'setGroupLeaders?eventName=' + eventName + '&barrels=' + barrels, groupedRuns)
            .then(data => resolve(data), error => reject(error));
        });
    }

    getTimer(key: string) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.timer + '/get?id=' + key)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getRecentTimers() {
        return this.api.getWithAuth(this.api.endpoints.timer + '/getRecentTimers');
    }

    startRunningClock(rodeoId, accountId) {
        return new Promise((resolve, reject) => {
            this.api.postWithAuth(this.api.endpoints.timer + '/startRunningClock?rodeoId=' + rodeoId + '&accountId=' + accountId)
            .then(data => resolve(data), error => reject(error));
        });
    }

    stopRunningClock(time, rodeoId, accountId) {
        return new Promise((resolve, reject) => {
            this.api.postWithAuth(this.api.endpoints.timer + '/stopRunningClock?time=' + time + '&rodeoId=' + rodeoId + '&accountId=' + accountId)
            .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/timer.service.ts